import FingerprintJS from "@fingerprintjs/fingerprintjs";
const fpPromise = FingerprintJS.load();

//  根据浏览器信息创建用户的唯一指纹
export async function createFingerprint() {
  const fp = await fpPromise;
  const result = await fp.get();
  return result.visitorId;
}

export function getStoreage(key) {
  return localStorage.getItem(key);
}

export function setStoreage(key, value) {
  return localStorage.setItem(key, value);
}
// 获取用户指纹
export async function getFingerprint() {
    let fingerprint = getStoreage("fingerprint");
    if (fingerprint) {
      return fingerprint;
    }
    fingerprint = await createFingerprint();
    setStoreage('fingerprint', fingerprint)
    return fingerprint;
}
  